import openDatabase from "../../IndexedDB/openDatabase";

const readEnumsFromIndexedDB = async (
  enumKeyNamesStr,
  dbName = "ERP_DB",
  storeName = "Enums",
  dbVersion = 1
) => {
  try {
    // Open the database and object store
    const db = await openDatabase(dbName, storeName, dbVersion);

    // Ensure the store exists
    if (!db.objectStoreNames.contains(storeName)) {
      throw new Error(`Object store '${storeName}' does not exist in the database`);
    }

    // Start a readonly transaction
    const transaction = db.transaction(storeName, "readonly");
    const store = transaction.objectStore(storeName);

    // Create an array of promises for fetching data for each key
    const fetchPromises = enumKeyNamesStr.split(",").map((key) => {
      return new Promise((resolve) => {
        const request = store.get(key);
        request.onsuccess = () => resolve({ key, value: request.result });
        request.onerror = () => resolve({ key, value: undefined }); // Resolve with undefined if error
      });
    });
    // Wait for all fetch operations to complete
    const results = await Promise.all(fetchPromises);
    // Separate found and not found enumKeyNamesStr
    const foundedEnums = {};
    const notFoundedEnumKeyNames = [];

    results.forEach(({ key, value }) => {
      if (value !== undefined) {
        foundedEnums[key] = value;
      } else {
        notFoundedEnumKeyNames.push(key);
      }
    });

    return { foundedEnums, notFoundedEnumKeyNames };
  } catch (error) {
    console.error("Error reading client data:", error);
    return { foundedEnums: {}, notFoundedEnumKeyNames: enumKeyNamesStr }; // Return all enumKeyNamesStr as not found in case of an error
  }
};

export default readEnumsFromIndexedDB;
